<template>
    <div>
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>

        <subNav leadStyle="2px solid #283254"></subNav>
        <div class="committeeComposition">
            <div class="wrap">
                <div class="title">Corporate Governance</div>
                <div class="committee">
                    <div class="headline">
                        Below is a summary of our committee structure and
                        membership information. To read more about any of the
                        committees, click on committee names in the chart below.
                    </div>
                    <div class="header">
                        <div></div>
                        <div>Audit Committee </div>
                        <div>Compensation Committee </div>
                        <!-- <div title='Nominating and Corporate Governance Committee' style='width:400px; white-space:nowrap; text-overflow:ellipsis; overflow:hidden;'>
                            Nominating and Corporate ...
                        </div> -->
                        <div >Nominating and Corporate <br>Governance Committee </div>
                        <!-- <div>Executive Committee </div> -->
                    </div>
                    <div>
                        <ul>
                            <li
                                v-for="(item, index) in resultList"
                                :key="index"
                            >
                            <span>
                                    <label>
                                        <a :href="('/#/governanceDocuments/#person_'+item.memberid)">{{ item.name }}</a>
                                    </label>
                                    <span>
                                        <img
                                            v-if="item.Executive == 4"
                                            src="@/assets/investor-Relation/tel.png"
                                            alt=""
                                        />
                                    </span>
                            </span>
                                <span>
                                    <img
                                        v-if="item.Audit == 2"
                                        src="@/assets/investor-Relation/Chairperson.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Audit == 1"
                                        src="@/assets/investor-Relation/member.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Audit == 3"
                                        src="@/assets/investor-Relation/leader.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Audit == 4"
                                        src="@/assets/investor-Relation/tel.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Audit == 5"
                                        src="@/assets/investor-Relation/star.png"
                                        alt=""
                                    />
                                </span>
                                <span
                                    >
                                    <img
                                        v-if="item.Compensation == 1"
                                        src="@/assets/investor-Relation/Chairperson.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Compensation == 2"
                                        src="@/assets/investor-Relation/member.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Compensation == 3"
                                        src="@/assets/investor-Relation/leader.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Compensation == 4"
                                        src="@/assets/investor-Relation/tel.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Compensation == 5"
                                        src="@/assets/investor-Relation/star.png"
                                        alt=""
                                    />
                                </span>
                                <span
                                    ><img
                                        v-if="item.Corporate == 1"
                                        src="@/assets/investor-Relation/Chairperson.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Corporate == 2"
                                        src="@/assets/investor-Relation/member.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Corporate == 3"
                                        src="@/assets/investor-Relation/leader.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Corporate == 4"
                                        src="@/assets/investor-Relation/tel.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Corporate == 5"
                                        src="@/assets/investor-Relation/star.png"
                                        alt=""
                                    /></span>
                                <!-- <span
                                    ><img
                                        v-if="item.Executive == 1"
                                        src="@/assets/investor-Relation/Chairperson.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Executive == 2"
                                        src="@/assets/investor-Relation/member.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Executive == 3"
                                        src="@/assets/investor-Relation/leader.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Executive == 4"
                                        src="@/assets/investor-Relation/tel.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.Executive == 5"
                                        src="@/assets/investor-Relation/star.png"
                                        alt=""
                                    /></span> -->
                            </li>
                        </ul>
                    </div>
                    <div class="reminder">
                        <span>
                            <img
                                src="@/assets/investor-Relation/Chairperson.png"
                                alt=""
                            />Chairperson</span
                        >
                        <span
                            ><img
                                src="@/assets/investor-Relation/member.png"
                                alt=""
                            />Member</span
                        >
                        <!-- <span
                            ><img
                                src="@/assets/investor-Relation/leader.png"
                                alt=""
                            />Lead Director</span
                        > -->
                        <span
                            ><img
                                src="@/assets/investor-Relation/tel.png"
                                alt=""
                            />Financial Expert</span
                        >
                        <!-- <span
                            ><img
                                src="@/assets/investor-Relation/star.png"
                                alt=""
                            />Chairman of the Board</span
                        > -->
                    </div>
                </div>
                <div class="downlists">
                    <table>
                        <tr class="titleRow">
                            <td>Committee Charters</td>
                            <td>Governance Documents</td>
                        </tr>
                        <tr class="fileRow">
                            <td><a href="./doc/MultiMetaVerse Holdings Limited - Auditing Committee Charter.pdf">Audit Committee <img src="@/assets/investor-Relation/pdf.png" alt="" /></a></td>
                            <td><a href="./doc/MultiMetaVerse Holdings Limited Model Performance Mini Corp Registry Stamped Restated Mem and Arts - 04 Jan 2023.PDF">Memorandum and Articles of Association <img src="@/assets/investor-Relation/pdf.png" alt="" /></a></td>
                        </tr>
                        <tr class="fileRow">
                            <td><a href="./doc/MultiMetaVerse Holdings Limited - Compensation Committee Charter.pdf">Compensation Committee <img src="@/assets/investor-Relation/pdf.png" alt="" /></a></td>
                            <td><a href="./doc/MultiMetaVerse Holdings Limited - Code of Business Conduct and Ethics.pdf">Code of Business Conduct and Ethics <img src="@/assets/investor-Relation/pdf.png" alt="" /></a></td>
                        </tr>
                        <tr class="fileRow">
                            <td><a href="./doc/MultiMetaVerse Holdings Limited - Nomination and Corporate Governance Committee Charter.pdf">Nominating and Corporate Governance Committee <img src="@/assets/investor-Relation/pdf.png" alt="" /></a></td>
                            <td><a href="javascript:void(0);">Related Party Transaction Policy (Pending)</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
import { createLogger } from 'vuex';
export default {
    name: "committeeComposition",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
            committeeList: [],
            resultList: [],
        };
    },
    created() {
        this.$http.getIrCommittee().then((res) => {
            console.log(res)
            res.map((item, index) => {
                return this.committeeList.push(item.identity);
            });
            let list = res.map((item, index) => {
                return { name: item.name , memberid: item.memberid};
            });
            let result = {};
            console.log(this.committeeList)
            for(var i=0;i<this.committeeList.length;i++){
                for(var j=0;j<this.committeeList[i].length;j++){
                    if (this.committeeList[i][j].committee == 1) {
                        //Audit审计
                        result.Audit= this.committeeList[i][j].identity
                    } else if (this.committeeList[i][j].committee == 2) {
                        //Compensation薪酬
                        result.Compensation= this.committeeList[i][j].identity
                    } else if (this.committeeList[i][j].committee == 3) {
                        //Corporate Governance公司管理
                        result.Corporate= this.committeeList[i][j].identity
                    } else if (this.committeeList[i][j].committee == 4) {
                        //Executive执行为会员
                        result.Executive= this.committeeList[i][j].identity
                    }
                };
                this.resultList.push(JSON.parse(JSON.stringify(result)))
            };
            this.resultList = this.resultList.map((item, index) => {
                return { ...item, ...list[index] };
            });
        });
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.committeeComposition {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .committee {
        border: 1px solid #dcdcdc;
        padding: 30px;
        .headline {
            padding: 30px;
            color: #333333;
            font-size: 16px;
            font-family: 'Lucida Bright';
        }
        .header {
            display: flex;
            align-items: center;
            div {
                width: 25%;
                text-align: center;
                height: 58px;
                color: #f2f2f2;
                background: #283254;
                align-items: center;
                display: flex;
                align-items: center;
                justify-content: center;
                // line-height: 58px;
            }
        }
        ul {
            li {
                height: 55px;
                line-height: 55px;
                border-bottom: 1px solid #e9e9e9;
                span {
                    display: inline-block;
                    text-align: center;
                    color: #283254;
                    width: 25%;
                    img {
                        vertical-align: middle;
                    }
                }
                span:nth-child(1) {
                    text-align: center;
                    font-family: 'Lucida Bright';
                    label {
                        border-bottom: 2px solid #9ea0ac;
                        margin-right: 10px;
                    }
                }
            }
        }
        .reminder {
            margin: 45px 0;
            span {
                margin-right: 45px;
                img {
                    margin-right: 10px;
                }
            }
        }
    }
    .downlists {
        width: 100%;
        padding: 10px 0px 0px 30px;
        table {
            width: 80%;
            tr {
                height: 35px;
            }
            .titleRow{
                font-size: 24px;
                font-weight: bold;
            }
            .fileRow {

            }
            .fileRow a :hover{
                text-decoration: underline;
            }
            .fileRow img {
              width: 18px;
              height: 18px;
            }
        }
    }
}
.clear {
    clear: both;
}
</style>
